import LeadFormMultiStep from "../components/LeadFormMultiStep";

export default function GetOffer() {
  return (
    <section className="py-16 sm:py-24 bg-offwhite min-h-[70vh]">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-money font-bold uppercase tracking-widest text-sm mb-3">You're almost there</p>
          <h1 className="font-display text-3xl sm:text-5xl text-navy">Tell us a bit more — get a real offer in 24 hours.</h1>
          <p className="mt-3 text-lg text-muted">Takes about 60 seconds. No credit check, no obligation.</p>
        </div>
        <LeadFormMultiStep />
      </div>
    </section>
  );
}
